import { combineReducers } from 'redux';
import AuthReducer from './auth';
import AccountingReducer from './modules/accounting/index';
import ChartReducer from './modules/chart/index';
import HRReducer from './modules/hr/index';
import LogReducer from './modules/log/index';
import MarketingReducer from './modules/marketing/index';
import MasterReducer from './modules/master/index';
import MutationReducer from './modules/mutation/index';
import NewsReducer from './modules/news/index';
import PurchasingReducer from './modules/purchasing/index';
import ReportReducer from './modules/report/index';
import SalesReducer from './modules/sales/index';
import WarehouseReducer from './modules/warehouse/index';
import UserReducer from './modules/user/index';

export default combineReducers({
    ...AccountingReducer,
    ...ChartReducer,
    ...HRReducer,
    ...LogReducer,
    ...MarketingReducer,
    ...MasterReducer,
    ...MutationReducer,
    ...NewsReducer,
    ...PurchasingReducer,
    ...ReportReducer,
    ...SalesReducer,
    ...WarehouseReducer,
    ...UserReducer,
    // navigation: NavigationStateReducer,
    auth: AuthReducer,
})